import { bff, createBFFHandlers } from '~/framework/bff';
import { getServerSideMonolithClient } from '~/framework';
import {
   getExternalTrainingModulesDrafts,
   GetExternalTrainingModulesDraftsOptions,
} from '~/monolith-api';

const PAGE_SIZE = 20;

export default createBFFHandlers({
   post: async (req, res) => {
      const monolithClient = getServerSideMonolithClient(req);
      const result = await getExternalTrainingModulesDrafts({
         apiClient: monolithClient,
         ...req.body,
      });
      res.status(200).json(result);
   },
});

export const getDrafts = (
   options?: GetExternalTrainingModulesDraftsOptions,
   page?: number
): ReturnType<typeof getExternalTrainingModulesDrafts> => {
   const limit = options?.limit ?? PAGE_SIZE;
   const offset = page ? limit * (page - 1) : 0;

   return bff()
      .post('/external-training-modules/getDrafts', {
         offset,
         limit,
         ...options,
      })
      .then(response => response.data);
};
